const state = {
    collapse: true,
    user: {},
    siteInfo: {},
    entityIds: [],
    isFirstLogin: false,
    currentMenu: [],
    showMenuCodeList: [], // 站点选择展现的menuCode
    userIdentity: null
}
const getters = {
    getUser: (state) => state.user,
    getSite: (state) => state.siteInfo,
    getEntityIds: (state) => state.entityIds,
    getCollapse: (state) => state.collapse,
    getIsFirstLogin: (state) => state.isFirstLogin,
    getCurrentMenu: (state) => state.currentMenu,
    getShowMenuCodeList: (state) => state.showMenuCodeList,
    getUserIdentity: (state) => state.userIdentity
}

function setMenu(state) {
    const { siteInfo, user } = state
    const { isKccLite, isSiteAdmin } = siteInfo
    const sourceMenuList = isKccLite ? user.kccLiteMenuList : user.menuList
    if (!isSiteAdmin) {
        let menuList = []
        if (sourceMenuList) menuList.push(...sourceMenuList)
        menuList.forEach((i, n) => {
            if (i.menuCode == 'site000') {
                menuList.splice(n, 1)
            }
        })
        state.currentMenu = menuList
    } else {
        state.currentMenu = sourceMenuList
    }
}

const mutations = {
    setUser: (state, payLoad) => {
        state.user = Object.assign({}, payLoad)
        setMenu(state)
    },
    setSite: (state, payLoad) => {
        state.siteInfo = { ...payLoad }
        setMenu(state)
    },
    setEntityIds: (state, payLoad) => (state.entityIds = Object.assign([], payLoad)),
    setCollapse: (state, payLoad) => (state.collapse = payLoad),
    // setCurrentMenu: (state, payLoad) => {},
    setIsFirstLogin: (state, payLoad) => (state.isFirstLogin = payLoad),
    setShowMenuCodeList: (state, payLoad) => {
        state.showMenuCodeList = payLoad
    },
    setUserIdentity: (state, payLoad) => {
        state.userIdentity = payLoad
    }
}
const actions = {}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
